var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('live-hub-form',{attrs:{"live-hub-id":_vm.emptyGuid},on:{"submit":_vm.addLiveHub,"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }